const PodcastLists = (episodes = [], action) =>{
    switch (action.type) {
        case 'PODCASTITEM':
            return action.payload;
        default:
            return episodes;
    }
}

export default PodcastLists;